module.exports = __webpack_public_path__ + "static/header-4c696e8ed48747b10fcc0afda9570320.jpg";